import { render } from "./AboutSectionListSlider.vue?vue&type=template&id=2ad43494"
import script from "./AboutSectionListSlider.vue?vue&type=script&lang=js"
export * from "./AboutSectionListSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__